export default "__VITE_PUBLIC_ASSET__da835621__"